import { ApiResponse } from 'apisauce';

import config from '../../config';
import { ReportingFilePayloadData, ReportParameters, ReportType } from '../store/reportingFile/types';

import { BaseRequestService } from './BaseRequest.service';
import { IReportingFileService } from './types';

const API_PATH = {
  getFile: '/v2/reports-10n/download-order-confirmation-report',
};

export class ReportingFileService extends BaseRequestService implements IReportingFileService {
  private static instance: ReportingFileService;

  protected getBaseUrl(): string {
    return config.reportingFile.url;
  }

  private constructor() {
    super();
  }

  static getInstance(): ReportingFileService {
    if (!this.instance) {
      this.instance = new ReportingFileService();
    }
    return this.instance;
  }

  get(requestBody: ReportingFilePayloadData): Promise<ApiResponse<string>> {
    return this.api.post<string>(API_PATH.getFile, requestBody);
  }

  getReport(params: ReportParameters): Promise<ApiResponse<ReportType>> {
    const { accountReferenceId, fromDate, toDate, url } = params;
    return this.api.post(url, { accountReferenceId, fromDate, toDate });
  }
}
